import { render, staticRenderFns } from "./protocolConfig.vue?vue&type=template&id=be4aae60"
import script from "./protocolConfig.vue?vue&type=script&lang=js"
export * from "./protocolConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports